import React from "react";
import { ICONS } from "../../utils/icons";

export default function AttendanceStatsSection({
  GlassCard,
  dailyStats,
  filteredCount,
  isMobile,
  targetGroup,
}) {
  return (
    <div className="grid grid-cols-4 gap-2 md:gap-4 mb-4 md:mb-8">
      <GlassCard className={`flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-1 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all ${isMobile ? "p-2" : "p-5"}`} noHover>
        {!isMobile && <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-blue-400"></div>}
        <div className="relative z-10 flex flex-col items-center w-full">
          <div className={`rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-1 ${isMobile ? "p-1.5" : "p-3 mb-2"}`}>
            <img src={targetGroup === "teachers" ? ICONS.teacher : ICONS.student} width={isMobile ? 20 : 36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className={`text-gray-500 font-bold tracking-wide mb-0.5 ${isMobile ? "text-[10px]" : "text-sm"}`}>총 인원</h3>
          <div className="flex items-end gap-1 mb-1 justify-center">
            <span className={`font-black text-gray-800 font-do-hyeon leading-none ${isMobile ? "text-xl" : "text-4xl"}`}>{filteredCount}</span>
            {!isMobile && <span className="text-sm font-bold text-gray-400 mb-1">명</span>}
          </div>
          {!isMobile && <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">등록 인원</span>}
        </div>
      </GlassCard>

      <GlassCard className={`flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-1 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all ${isMobile ? "p-2" : "p-5"}`} noHover>
        {!isMobile && <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-green-400"></div>}
        <div className="relative z-10 flex flex-col items-center w-full">
          <div className={`rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-1 ${isMobile ? "p-1.5" : "p-3 mb-2"}`}>
            <img src={ICONS.attendance} width={isMobile ? 20 : 36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className={`text-gray-400 font-bold tracking-wide mb-0.5 ${isMobile ? "text-[10px]" : "text-sm"}`}>출석률</h3>
          <div className="flex items-end gap-1 mb-1 justify-center">
            <span className={`font-black text-[#2C3E30] font-do-hyeon leading-none ${isMobile ? "text-xl" : "text-4xl"}`}>
              {filteredCount > 0 ? Math.round(((dailyStats.present + dailyStats.late) / filteredCount) * 100) : 0}
            </span>
            <span className={`font-bold text-gray-400 ${isMobile ? "text-[10px] mb-0.5" : "text-sm mb-1"}`}>%</span>
          </div>
          {!isMobile && <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">오늘 기준</span>}
        </div>
      </GlassCard>

      <GlassCard className={`flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-1 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all ${isMobile ? "p-2" : "p-5"}`} noHover>
        {!isMobile && <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-red-400"></div>}
        <div className="relative z-10 flex flex-col items-center w-full">
          <div className={`rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-1 ${isMobile ? "p-1.5" : "p-3 mb-2"}`}>
            <img src={ICONS.warning} width={isMobile ? 20 : 36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className={`text-gray-400 font-bold tracking-wide mb-0.5 ${isMobile ? "text-[10px]" : "text-sm"}`}>결석</h3>
          <div className="flex items-end gap-1 mb-1 justify-center">
            <span className={`font-black text-gray-800 font-do-hyeon leading-none ${isMobile ? "text-xl" : "text-4xl"}`}>{dailyStats.absent}</span>
            {!isMobile && <span className="text-sm font-bold text-gray-400 mb-1">명</span>}
          </div>
          {!isMobile && <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">관리 필요</span>}
        </div>
      </GlassCard>

      <GlassCard className={`flex flex-col items-center justify-center text-center h-full relative overflow-hidden gap-1 border border-white/60 bg-white rounded-[2rem] shadow-sm hover:shadow-md transition-all ${isMobile ? "p-2" : "p-5"}`} noHover>
        {!isMobile && <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full opacity-10 blur-2xl bg-yellow-400"></div>}
        <div className="relative z-10 flex flex-col items-center w-full">
          <div className={`rounded-2xl bg-gray-50 shadow-sm border border-gray-100 mb-1 ${isMobile ? "p-1.5" : "p-3 mb-2"}`}>
            <img src={ICONS.memo} width={isMobile ? 20 : 36} alt="icon" className="drop-shadow-sm" />
          </div>
          <h3 className={`text-gray-400 font-bold tracking-wide mb-0.5 ${isMobile ? "text-[10px]" : "text-sm"}`}>지각</h3>
          <div className="flex items-end gap-1 mb-1 justify-center">
            <span className={`font-black text-gray-800 font-do-hyeon leading-none ${isMobile ? "text-xl" : "text-4xl"}`}>{dailyStats.late}</span>
            {!isMobile && <span className="text-sm font-bold text-gray-400 mb-1">명</span>}
          </div>
          {!isMobile && <span className="text-xs text-gray-400 bg-gray-50 px-2.5 py-0.5 rounded-full border border-gray-100">특이 사항</span>}
        </div>
      </GlassCard>
    </div>
  );
}
